// src/components/blog/search/EmptyState.tsx

'use client'

import type { ReactNode } from 'react'
import Link from 'next/link'
import RiSearchLine from '~/icons/remix/generated/RiSearchLine'

interface EmptyStateProps {
  query?: string
}

export function EmptyState({ query }: EmptyStateProps): ReactNode {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-gray-200/60 bg-white p-12 text-center dark:border-gray-800/60 dark:bg-gray-900">
      <div className="absolute inset-0 bg-grid-gray-900/[0.04] [mask-image:linear-gradient(0deg,white,rgba(255,255,255,0.6))] dark:bg-grid-white/[0.04]" />
      <div className="relative mx-auto max-w-lg">
        <RiSearchLine className="mx-auto h-12 w-12 text-gray-400" aria-hidden="true" />
        <h2 className="mt-4 text-2xl font-semibold text-gray-900 dark:text-white">
          {query ? (
            <>No results found for &ldquo;{query}&rdquo;</>
          ) : (
            <>Start your search</>
          )}
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          {query ? (
            <>Try adjusting your search terms or filters to find what you&apos;re looking for.</>
          ) : (
            <>Search our collection of articles about creative testing, ad optimization, and performance marketing.</>
          )}
        </p>
        <div className="mt-6 flex items-center justify-center gap-4">
          <Link
            href="/blog"
            className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500"
          >
            Browse Latest Articles
          </Link>
          <Link
            href="/blog/topics"
            className="inline-flex items-center justify-center rounded-lg bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-white dark:ring-gray-700 dark:hover:bg-gray-700"
          >
            View All Topics
          </Link>
        </div>
      </div>
    </div>
  )
} 